import dayjs from 'dayjs'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { useState } from 'react'

import { type CaseHistoryItem } from '@/lib/queries/types'
import { cn } from '@/lib/utils'

export interface HistoryItemProps {
  historyItem: CaseHistoryItem
}

export const HistoryItem = ({ historyItem }: HistoryItemProps) => {
  const { type, ...rest } = historyItem

  return (
    <>
      {type === 'history' && <HistoryMessage {...rest} />}
      {type === 'status' && <StatusMessage {...rest} />}
    </>
  )
}

const HistoryMessage = ({ title, message, received_date }: Omit<HistoryItemProps['historyItem'], 'type'>) => {
  return (
    <div className={cn('flex-1', 'rounded-lg', 'px-5 py-4', 'bg-sky-100')}>
      {title && <div className={cn('flex justify-between', 'mb-2', 'text-sm')}>{title}</div>}
      <div className={cn('text-[13px] font-normal leading-[18px] text-[#555]')}>{message}</div>
      <div className={cn('text-xs text-accent-foreground', 'mt-2')}>{dayjs(received_date).format('D MMM YYYY')}</div>
    </div>
  )
}

const StatusMessage = ({ title, message, received_date }: Omit<HistoryItemProps['historyItem'], 'type'>) => {
  const [showsMessage, setShowsMessage] = useState(false)

  return (
    <div className={cn('flex-1', 'rounded-lg', 'px-5 py-4', 'bg-secondary')}>
      <div className={cn('flex justify-between', 'mb-2', 'text-sm')}>
        {title}
        {message && (
          <button
            type="button"
            className={cn('self-start', 'ml-[18px]')}
            aria-label={showsMessage ? 'Hide message' : 'Show message'}
            onClick={() => setShowsMessage((prev) => !prev)}
          >
            {showsMessage && <ChevronUpIcon size={24} />}
            {!showsMessage && <ChevronDownIcon size={24} />}
          </button>
        )}
      </div>
      {showsMessage && <div className={cn('text-[13px] font-normal leading-[18px] text-[#555]')}>{message}</div>}
      <div className={cn('text-xs text-accent-foreground', 'mt-2')}>{dayjs(received_date).format('D MMM YYYY')}</div>
    </div>
  )
}
